export const assertNotEmpty = <T>(value: Ref<T | null | undefined>, error: () => Error): asserts value is Ref<T> => {
  if (value.value === null || value.value === undefined) throw error();
};
